import { useState, type ChangeEvent } from 'react';
import { User } from 'lucide-react';
import type { NuevoClienteDraft } from '../../types';
import { Modal } from '../ui/Modal';

interface Props {
  nombreInicial: string;
  onGuardar: (draft: NuevoClienteDraft) => void;
  onCancelar: () => void;
}

export function FormularioCliente({ nombreInicial, onGuardar, onCancelar }: Props) {
  const [draft, setDraft] = useState<NuevoClienteDraft>({
    nombre: nombreInicial,
    telefono: '',
    email: '',
    notas: '',
  });

  const guardar = () => {
    if (!draft.nombre || !draft.telefono) {
      alert('Por favor completa nombre y teléfono del cliente');
      return;
    }
    onGuardar(draft);
  };

  return (
    <Modal onClose={onCancelar}>
      <h2 className="text-xl font-bold text-gray-800 mb-4">
        <User size={24} className="inline mr-2" />
        Agregar Nuevo Cliente
      </h2>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Nombre *</label>
          <input
            type="text"
            value={draft.nombre}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setDraft({ ...draft, nombre: e.target.value })
            }
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            placeholder="Nombre completo"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Teléfono *</label>
          <input
            type="tel"
            value={draft.telefono}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setDraft({ ...draft, telefono: e.target.value })
            }
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            placeholder="Teléfono con lada"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Email (opcional)</label>
          <input
            type="email"
            value={draft.email}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setDraft({ ...draft, email: e.target.value })
            }
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            placeholder="correo@ejemplo.com"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Notas (opcional)</label>
          <textarea
            value={draft.notas}
            onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
              setDraft({ ...draft, notas: e.target.value })
            }
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            rows={2}
            placeholder="Preferencias, observaciones..."
          />
        </div>
      </div>
      <div className="flex gap-3 mt-6">
        <button
          onClick={guardar}
          className="flex-1 bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-lg font-medium transition-colors"
        >
          Guardar Cliente
        </button>
        <button
          onClick={onCancelar}
          className="px-6 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          Cancelar
        </button>
      </div>
    </Modal>
  );
}
